import { render, staticRenderFns } from "./AthletePreview.vue?vue&type=template&id=1a04fb55&"
import script from "./AthletePreview.vue?vue&type=script&lang=ts&"
export * from "./AthletePreview.vue?vue&type=script&lang=ts&"
import style0 from "./AthletePreview.vue?vue&type=style&index=0&id=1a04fb55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports